import { EmployeeSlim } from './employee-slim.model';

export enum SpecialRoleType {
  SpecialResponsibility = 'SpecialResponsibility',
  BusinessPartner = 'BusinessPartner',
  CountryResponsibility = 'CountryResponsibility'
}

export class SpecialRole {
  id?: string;
  employee?: EmployeeSlim;
  employeeId?: string;
  title?: string;
  organisationId?: string;
  validFrom?: string;
  type: SpecialRoleType;
}

export function toRoleType(roleType: string): SpecialRoleType {
  switch (roleType) {
    case SpecialRoleType.BusinessPartner:
      return SpecialRoleType.BusinessPartner;
    case SpecialRoleType.SpecialResponsibility:
      return SpecialRoleType.SpecialResponsibility;
    case SpecialRoleType.CountryResponsibility:
      return SpecialRoleType.CountryResponsibility;
    default:
      throw new Error(`Unsupported role type ${roleType}`);
  }
}
